import React from 'react';
import styled from 'styled-components';

import { getInitials } from '../utils/initials';

import Avatar, { AvatarItem } from '@atlaskit/avatar';
import { colors, fontFamily } from '@atlaskit/theme';

export type AccountDetailsProps = {
  readonly userName: string;
  readonly userEmail: string;
  readonly avatarSrc?: string;
};

export function AccountDetails({
  userName,
  userEmail,
  avatarSrc
}: AccountDetailsProps) {
  return (
    <AvatarWrapper>
      <AvatarItem
        avatar={
          avatarSrc !== undefined ? (
            <Avatar src={avatarSrc} />
          ) : (
            <Avatar
              component={({ className, ...props }: any) => (
                <div className={className}>
                  <Initials {...props}>{getInitials(userName)}</Initials>
                </div>
              )}
            />
          )
        }
        key={userEmail}
        primaryText={userName}
        secondaryText={userEmail}
      />
    </AvatarWrapper>
  );
}

const Initials = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  font-family: ${fontFamily};
  font-size: 10px;
  line-height: 10px;
  color: ${colors.N500};

  width: 100%;
  height: 100%;
  background-color: ${colors.N40};
  border-radius: 50%;
`;

const AvatarWrapper = styled.div`
  margin: -16px -16px -16px -16px;
`;
